export default {
  // 模块名称
  log: {
    // 按钮类
    button: {
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      close: 'Close',
      detail: 'Detail'
    },
    // 文字标签类
    label: {
      no: 'No',
      module: 'Module',
      function: 'Function',
      type: 'Type',
      account: 'Account',
      name: 'Name',
      timeRange: 'TimeRange',
      operatTime: 'Time',
      operatResult: 'Result',
      ip: 'IP',
      desc: 'Description',
      operations: 'Operations',
      to: 'To'
    },
    // 提示类
    placeholder: {
      select: 'Select',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: 'Log details',
      exportName: 'Log record'
    }
  }
}